import { LitElement, html, css, unsafeCSS, nothing } from 'lit';
import styles from './card-document.scss?inline';

export default class SotbitCardDocument extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        documentHref: { type: String, attribute: 'document-href' },
        documentName: { type: String, attribute: 'document-name' },
        documentSize: { type: String, attribute: 'document-size' },
        documentIcon: { type: String, attribute: 'document-icon' },
        size: { type: String, reflect: true },
        download: { type: Boolean },
        target: { type: String },
        _hasMeta: { state: true },
        _hasSize: { state: true },
        _hasIconRight: { state: true },
    };

    constructor() {
        super();

        this.documentHref = null;
        this.documentName = null;
        this.documentSize = null;
        this.documentIcon = 'docs';
        this.size = null;
        this.download = false;
        this.target = null;
        this._hasMeta = false;
        this._hasSize = false;
        this._hasIconRight = false;
    }

    get _iconSize() {
        return this.size === 's' ? 'sl' : 'l';
    }

    _slotHasContent(slot) {
        return slot
            .assignedNodes({ flatten: true })
            .some((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    return true;
                }

                return node.nodeType === Node.TEXT_NODE && Boolean(node.textContent?.trim());
            });
    }

    _onMetaSlotChange(event) {
        this._hasMeta = this._slotHasContent(event.target);
    }

    _onSizeSlotChange(event) {
        this._hasSize = this._slotHasContent(event.target) || Boolean(this.documentSize);
    }

    _onIconRightSlotChange(event) {
        this._hasIconRight = this._slotHasContent(event.target);
    }

    _renderDefaultIconRight() {
        if (!this.documentHref) {
            return nothing;
        }

        return html`<sotbit-icon
            size="${this.size === 's' ? 'sl' : 'm'}"
            pointer
            variant="primary"
            icon="download"
        ></sotbit-icon>`;
    }

    render() {
        const showIconRight = Boolean(this.documentHref) || this._hasIconRight;
        const showSize = this._hasSize || Boolean(this.documentSize);
        const bodyClass = [
            'card-body',
            this._hasMeta ? 'has-meta' : '',
            showSize ? 'has-size' : '',
        ]
            .filter(Boolean)
            .join(' ');

        return html`
            <a
                class="card"
                href="${this.documentHref || nothing}"
                ?download="${this.download}"
                target="${this.target || nothing}"
            >
                <div class="outline"></div>
                <div class="icon-left">
                    <slot name="icon-left">
                        <sotbit-icon icon="${this.documentIcon}" size="${this._iconSize}" no-padding></sotbit-icon>
                    </slot>
                </div>
                <div class="${bodyClass}">
                    <div class="name">
                        <slot name="name">
                            ${this.documentName
                                ? html`<span>${this.documentName}</span>`
                                : nothing}
                        </slot>
                    </div>
                    <div class="meta">
                        <slot name="meta" @slotchange=${this._onMetaSlotChange}></slot>
                    </div>
                    <div class="size">
                        <slot name="size" @slotchange=${this._onSizeSlotChange}>
                            ${this.documentSize || nothing}
                        </slot>
                    </div>
                </div>
                ${showIconRight
                    ? html`
                          <div class="icon-right">
                              <slot name="icon-right" @slotchange=${this._onIconRightSlotChange}>
                                  ${this._renderDefaultIconRight()}
                              </slot>
                          </div>
                      `
                    : html`
                          <slot
                              name="icon-right"
                              @slotchange=${this._onIconRightSlotChange}
                              hidden
                          ></slot>
                      `}
            </a>
        `;
    }
}
